'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function JOFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-rptegc54z", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-gzxn7i1k9", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-athvymsna" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-ihbhkbvi1", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-3zud7qf0c" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-athvymsna", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-3zud7qf0c", d: "M0 0v24l20-12z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-rptegc54z)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-athvymsna" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 0h32v8H0z", mask: "url(#mantine-gzxn7i1k9)" }), /* @__PURE__ */ React.createElement("path", { fill: "#093", d: "M0 16h32v8H0z", mask: "url(#mantine-gzxn7i1k9)" }), /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-3zud7qf0c" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M9.002 13.87L7.132 15l.426-2.204L6 11.146l2.11-.088L9.001 9l.892 2.058H12l-1.554 1.738.468 2.204z",
        mask: "url(#mantine-ihbhkbvi1)"
      }
    )))
  );
}

export { JOFlag };
//# sourceMappingURL=JO.mjs.map
